import { Link } from "react-router-dom";
import { Watch, ArrowRight } from "lucide-react";

// Shared smartwatch upsell banner → free waitlist (no payments on this site).
// variant "track"  → calculators hub copy
// variant "fix"    → programmatic lander copy
export default function SmartwatchCTA({ variant = "track", source = "tools" }) {
  const copy =
    variant === "fix"
      ? "Want automated, continuous lifestyle tracking? Join the free waitlist for smartwatch sync — coming soon."
      : "Want automated, continuous tracking without manual typing? Join the free waitlist for smartwatch sync — coming soon.";
  return (
    <div
      data-testid={`smartwatch-cta-${variant}`}
      className="mt-5 rounded-2xl border border-cyan-400/25 bg-gradient-to-r from-[#0B3D91]/25 to-cyan-500/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3"
    >
      <div className="w-10 h-10 rounded-xl bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center shrink-0">
        <Watch className="w-5 h-5 text-cyan-300" />
      </div>
      <p className="flex-1 text-xs sm:text-sm text-zinc-300 leading-relaxed">{copy}</p>
      <Link
        to={`/waitlist?source=${source}`}
        data-testid={`smartwatch-cta-link-${variant}`}
        className="inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full text-xs font-semibold btn-glow text-white shrink-0"
      >
        Join free waitlist
        <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  );
}
